/**
 * Generated by scripts/auth-route-parity.mjs. Do not edit.
 * Wave 0 Auth Finality operation catalog (live rust + embedded scan).
 */
import type { AthenaAuthOperationDefinition } from "./operations.ts";

export const ATHENA_AUTH_OPERATIONS: AthenaAuthOperationDefinition[] = [
  {
    "id": "authorization.roles.by",
    "method": "DELETE",
    "path": "/authorization/roles/{id}",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "jwt.jwks",
    "method": "GET",
    "path": "/.well-known/jwks.json",
    "capability": "jwt",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "oidc.discovery",
    "method": "GET",
    "path": "/.well-known/openid-configuration",
    "capability": "oidc",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "passkey.relatedOrigins",
    "method": "GET",
    "path": "/.well-known/webauthn",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "admin.emailEventType.list",
    "method": "GET",
    "path": "/admin/email-event-type/list",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": false
  },
  {
    "id": "admin.emailFailure.get",
    "method": "GET",
    "path": "/admin/email-failure/get",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": false
  },
  {
    "id": "admin.emailFailure.list",
    "method": "GET",
    "path": "/admin/email-failure/list",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": false
  },
  {
    "id": "admin.emailTemplate.get",
    "method": "GET",
    "path": "/admin/email-template/get",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": false
  },
  {
    "id": "admin.emailTemplate.list",
    "method": "GET",
    "path": "/admin/email-template/list",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": false
  },
  {
    "id": "admin.email.get",
    "method": "GET",
    "path": "/admin/email/get",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": false
  },
  {
    "id": "admin.email.list",
    "method": "GET",
    "path": "/admin/email/list",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": false
  },
  {
    "id": "apiKey.get",
    "method": "GET",
    "path": "/api-key/get",
    "capability": "apiKeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "apiKey.list",
    "method": "GET",
    "path": "/api-key/list",
    "capability": "apiKeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "authorization.audit",
    "method": "GET",
    "path": "/authorization/audit",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "authorization.rights",
    "method": "GET",
    "path": "/authorization/rights",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "authorization.roles",
    "method": "GET",
    "path": "/authorization/roles",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "authorization.roles.by",
    "method": "GET",
    "path": "/authorization/roles/{id}",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "authorization.snapshot",
    "method": "GET",
    "path": "/authorization/snapshot",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "social.callback",
    "method": "GET",
    "path": "/callback/{provider}",
    "capability": "social",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "user.email.verify.change",
    "method": "GET",
    "path": "/change-email/verify",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "user.delete.verify",
    "method": "GET",
    "path": "/delete-user/verify",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "email.list",
    "method": "GET",
    "path": "/email/list",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "session.get",
    "method": "GET",
    "path": "/get-session",
    "capability": "sessions",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "health.health",
    "method": "GET",
    "path": "/health",
    "capability": "health",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "account.list",
    "method": "GET",
    "path": "/list-accounts",
    "capability": "accounts",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "session.list",
    "method": "GET",
    "path": "/list-sessions",
    "capability": "sessions",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "health.ok",
    "method": "GET",
    "path": "/ok",
    "capability": "health",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "member.active",
    "method": "GET",
    "path": "/organization/get-active-member",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "organization.get",
    "method": "GET",
    "path": "/organization/get-full-organization",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "invitation.get",
    "method": "GET",
    "path": "/organization/get-invitation",
    "capability": "invitations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "organization.list",
    "method": "GET",
    "path": "/organization/list",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "invitation.list",
    "method": "GET",
    "path": "/organization/list-invitations",
    "capability": "invitations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "member.list",
    "method": "GET",
    "path": "/organization/list-members",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "invitation.listUser",
    "method": "GET",
    "path": "/organization/list-user-invitations",
    "capability": "invitations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "passkey.register.options",
    "method": "GET",
    "path": "/passkey/generate-register-options",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "passkey.list",
    "method": "GET",
    "path": "/passkey/list-user-passkeys",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "user.password.reset.token",
    "method": "GET",
    "path": "/reset-password/{token}",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "user.email.verify",
    "method": "GET",
    "path": "/verify-email",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false,
    "domainEvent": "user.email.verify"
  },
  {
    "id": "health.ok.head",
    "method": "HEAD",
    "path": "/ok",
    "capability": "health",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "public",
    "mutation": false
  },
  {
    "id": "authorization.roles.by",
    "method": "PATCH",
    "path": "/authorization/roles/{id}",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "admin.emailFailure.create",
    "method": "POST",
    "path": "/admin/email-failure/create",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.emailFailure.delete",
    "method": "POST",
    "path": "/admin/email-failure/delete",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.emailFailure.update",
    "method": "POST",
    "path": "/admin/email-failure/update",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.emailTemplate.create",
    "method": "POST",
    "path": "/admin/email-template/create",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.emailTemplate.delete",
    "method": "POST",
    "path": "/admin/email-template/delete",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.emailTemplate.send",
    "method": "POST",
    "path": "/admin/email-template/send",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.emailTemplate.update",
    "method": "POST",
    "path": "/admin/email-template/update",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.email.create",
    "method": "POST",
    "path": "/admin/email/create",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.email.delete",
    "method": "POST",
    "path": "/admin/email/delete",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "admin.email.update",
    "method": "POST",
    "path": "/admin/email/update",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "admin",
    "mutation": true
  },
  {
    "id": "apiKey.create",
    "method": "POST",
    "path": "/api-key/create",
    "capability": "apiKeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "apiKey.create"
  },
  {
    "id": "apiKey.delete",
    "method": "POST",
    "path": "/api-key/delete",
    "capability": "apiKeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "apiKey.delete"
  },
  {
    "id": "apiKey.deleteExpired",
    "method": "POST",
    "path": "/api-key/delete-all-expired-api-keys",
    "capability": "apiKeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "apiKey.get.post",
    "method": "POST",
    "path": "/api-key/get",
    "capability": "apiKeys",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "apiKey.update",
    "method": "POST",
    "path": "/api-key/update",
    "capability": "apiKeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "apiKey.update"
  },
  {
    "id": "apiKey.verify",
    "method": "POST",
    "path": "/api-key/verify",
    "capability": "apiKeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "authorization.roles",
    "method": "POST",
    "path": "/authorization/roles",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "authorization.roles.clone",
    "method": "POST",
    "path": "/authorization/roles/clone",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "callback.by",
    "method": "POST",
    "path": "/callback/{provider}",
    "capability": "social",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true
  },
  {
    "id": "user.email.update",
    "method": "POST",
    "path": "/change-email",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "user.email.update"
  },
  {
    "id": "user.email.verify.change.post",
    "method": "POST",
    "path": "/change-email/verify",
    "capability": "password",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true
  },
  {
    "id": "user.password.change",
    "method": "POST",
    "path": "/change-password",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "user.password.change"
  },
  {
    "id": "user.delete",
    "method": "POST",
    "path": "/delete-user",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "user.delete"
  },
  {
    "id": "user.password.forget",
    "method": "POST",
    "path": "/forget-password",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true
  },
  {
    "id": "jwt.accessToken",
    "method": "POST",
    "path": "/get-access-token",
    "capability": "jwt",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "session.get.post",
    "method": "POST",
    "path": "/get-session",
    "capability": "sessions",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "account.link",
    "method": "POST",
    "path": "/link-social",
    "capability": "social",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "account.link"
  },
  {
    "id": "invitation.accept",
    "method": "POST",
    "path": "/organization/accept-invitation",
    "capability": "invitations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.invitation.accept"
  },
  {
    "id": "member.add",
    "method": "POST",
    "path": "/organization/add-member",
    "capability": "organizations",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.member.add"
  },
  {
    "id": "invitation.cancel",
    "method": "POST",
    "path": "/organization/cancel-invitation",
    "capability": "invitations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.invitation.cancel"
  },
  {
    "id": "organization.checkSlug",
    "method": "POST",
    "path": "/organization/check-slug",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "organization.create",
    "method": "POST",
    "path": "/organization/create",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.create"
  },
  {
    "id": "organization.delete",
    "method": "POST",
    "path": "/organization/delete",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.delete"
  },
  {
    "id": "organization.hasPermission",
    "method": "POST",
    "path": "/organization/has-permission",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "invitation.create",
    "method": "POST",
    "path": "/organization/invite-member",
    "capability": "invitations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.invitation.create"
  },
  {
    "id": "invitation.reminder",
    "method": "POST",
    "path": "/organization/invite-member-reminder",
    "capability": "invitations",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.member.invite.reminder"
  },
  {
    "id": "organization.leave",
    "method": "POST",
    "path": "/organization/leave",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.member.remove"
  },
  {
    "id": "invitation.reject",
    "method": "POST",
    "path": "/organization/reject-invitation",
    "capability": "invitations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.invitation.reject"
  },
  {
    "id": "member.remove",
    "method": "POST",
    "path": "/organization/remove-member",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.member.remove"
  },
  {
    "id": "organization.setActive",
    "method": "POST",
    "path": "/organization/set-active",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "session.activeOrganization.update"
  },
  {
    "id": "organization.update",
    "method": "POST",
    "path": "/organization/update",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.update"
  },
  {
    "id": "member.role.update",
    "method": "POST",
    "path": "/organization/update-member-role",
    "capability": "organizations",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "organization.member.role.update"
  },
  {
    "id": "passkey.delete",
    "method": "POST",
    "path": "/passkey/delete-passkey",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "passkey.delete"
  },
  {
    "id": "passkey.authenticate.options",
    "method": "POST",
    "path": "/passkey/generate-authenticate-options",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "optional-session",
    "mutation": true
  },
  {
    "id": "passkey.update",
    "method": "POST",
    "path": "/passkey/update-passkey",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "passkey.update"
  },
  {
    "id": "passkey.authenticate.verify",
    "method": "POST",
    "path": "/passkey/verify-authentication",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true,
    "domainEvent": "session.issue"
  },
  {
    "id": "passkey.register.verify",
    "method": "POST",
    "path": "/passkey/verify-registration",
    "capability": "passkeys",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "passkey.register"
  },
  {
    "id": "jwt.refresh",
    "method": "POST",
    "path": "/refresh-token",
    "capability": "jwt",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "user.password.reset",
    "method": "POST",
    "path": "/reset-password",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true,
    "domainEvent": "user.password.reset"
  },
  {
    "id": "session.revoke.others",
    "method": "POST",
    "path": "/revoke-other-sessions",
    "capability": "sessions",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "session.revoke"
  },
  {
    "id": "session.revoke",
    "method": "POST",
    "path": "/revoke-session",
    "capability": "sessions",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "session.revoke"
  },
  {
    "id": "session.revoke.all",
    "method": "POST",
    "path": "/revoke-sessions",
    "capability": "sessions",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "session.revoke"
  },
  {
    "id": "email.securityAlert",
    "method": "POST",
    "path": "/send-security-alert",
    "capability": "email",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "user.security.alert"
  },
  {
    "id": "email.signIn",
    "method": "POST",
    "path": "/send-sign-in-email",
    "capability": "email",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "user.sign-in.email"
  },
  {
    "id": "user.email.verify.send",
    "method": "POST",
    "path": "/send-verification-email",
    "capability": "email",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true
  },
  {
    "id": "session.bridge.exchange",
    "method": "POST",
    "path": "/session/bridge/exchange",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true
  },
  {
    "id": "session.bridge.issue",
    "method": "POST",
    "path": "/session/bridge/issue",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "user.password.set",
    "method": "POST",
    "path": "/set-password",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "session.issue.email",
    "method": "POST",
    "path": "/sign-in/email",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true,
    "domainEvent": "session.issue"
  },
  {
    "id": "session.issue.social",
    "method": "POST",
    "path": "/sign-in/social",
    "capability": "social",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true,
    "domainEvent": "session.issue"
  },
  {
    "id": "session.issue.username",
    "method": "POST",
    "path": "/sign-in/username",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true,
    "domainEvent": "session.issue"
  },
  {
    "id": "session.revoke.current",
    "method": "POST",
    "path": "/sign-out",
    "capability": "sessions",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "session.revoke"
  },
  {
    "id": "user.create",
    "method": "POST",
    "path": "/sign-up/email",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true,
    "domainEvent": "user.create"
  },
  {
    "id": "jwt.token",
    "method": "POST",
    "path": "/token",
    "capability": "jwt",
    "rust": "supported",
    "embedded": "supported",
    "auth": "public",
    "mutation": true
  },
  {
    "id": "twoFactor.disable",
    "method": "POST",
    "path": "/two-factor/disable",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "twoFactor.disable"
  },
  {
    "id": "twoFactor.enable",
    "method": "POST",
    "path": "/two-factor/enable",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "twoFactor.enable"
  },
  {
    "id": "twoFactor.backupCodes.generate",
    "method": "POST",
    "path": "/two-factor/generate-backup-codes",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "twoFactor.getUri",
    "method": "POST",
    "path": "/two-factor/get-totp-uri",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": false
  },
  {
    "id": "twoFactor.emailOtp.send",
    "method": "POST",
    "path": "/two-factor/send-otp",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "twoFactor.backupCodes.consume",
    "method": "POST",
    "path": "/two-factor/verify-backup-code",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "twoFactor.emailOtp.verify",
    "method": "POST",
    "path": "/two-factor/verify-otp",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  },
  {
    "id": "twoFactor.verifyEnable",
    "method": "POST",
    "path": "/two-factor/verify-totp",
    "capability": "twoFactor",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "twoFactor.enable"
  },
  {
    "id": "account.unlink",
    "method": "POST",
    "path": "/unlink-account",
    "capability": "social",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "account.unlink"
  },
  {
    "id": "user.update",
    "method": "POST",
    "path": "/update-user",
    "capability": "password",
    "rust": "supported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true,
    "domainEvent": "user.update"
  },
  {
    "id": "authorization.roles.by.rights",
    "method": "PUT",
    "path": "/authorization/roles/{id}/rights",
    "capability": "sessions",
    "rust": "unsupported",
    "embedded": "supported",
    "auth": "session",
    "mutation": true
  }
];
